import { localeNumberWithFixed } from "psims/lib/formatters/numbers";
import { NotificationPart } from "../../../shared/notification-message";
import { StorageValidationField, StorageValidationResult } from "./mso-stockholding-storages-validation";

const FIELD_LABELS: { [key in StorageValidationField]: string } = {
  terminalName:             'terminal name',
  terminalLocation:         'terminal location',
  terminalCoOwned:          'terminal co-owned',
  terminalOwners:           'terminal owners',
  terminalOperator:         'terminal operator',
  physicalStorageCapacity:  'physical storage capacity',
  receiveProducts:          'receive products',
  distributeProducts:       'distribute products',
  nameOfOtherCompany:       'name of other company',
  typeOfArrangementTxt:     'type of arrangement',
  capacityReservedForCompany: 'capacity reserved for company',
  capacityReservedForYou:     'capacity reserved for you',
  delete:                   'delete row',
};

export function getStorageNotificationMessage(
  fieldName: StorageValidationField,
  onTargetClick: () => any,
  productName: string,
  validationResult: StorageValidationResult | null
): Array<NotificationPart> | undefined {
  if (validationResult == null) {
    return undefined;
  }

  const label = FIELD_LABELS[fieldName];
  const btn = { label: `Go to ${label} field`, onClick: onTargetClick, text: label };

  const parts: Array<NotificationPart> = [
    `For ${productName}: `,
  ];

  switch (validationResult.code) {
    case 'invalid_required':
      parts.push('a value for ');
      parts.push(btn);
      parts.push(' is required.');
      break;

    case 'character_limit':
      parts.push('the value in ');
      parts.push(btn);
      parts.push(` must be ${localeNumberWithFixed(validationResult.limit)} characters or fewer.`);
      break;

    case 'invalid_characters':
      parts.push('the value in ');
      parts.push(btn);
      parts.push(' must only contain letters, numbers, hyphens, apostrophes, and parentheses.');
      break;

    case 'inactive_product':
      parts.push('This product is inactive. Please enter these details into an active product if applicable. Delete ');
      parts.push({ label: 'Go to delete data button', onClick: onTargetClick, text: 'product data' });
      parts.push(' to continue.');
      break;
    case 'invalid_decimal':
      parts.push('the value in ');
      parts.push(btn);
      parts.push(` must be a number with up to ${validationResult.decimalPlaces} decimal places.`);
      break;  
  }

  return parts;
}